import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	withStyles,
	Typography,
	Link,
	Grid
} from '@material-ui/core';

import Highchart from "./Highchart";

const styles = theme => ({
	container: {
		height: theme.spacing(5),

		[theme.breakpoints.down('xs')]: {
			height: theme.spacing(10)
		}
	}
});

class SentimentChart extends Component {
	render() {
		let {classes, chartConfig, clusterName, linkUrl, linkTitle, clickPointText} = this.props;
		return (
			<React.Fragment>
				<Highchart chartConfig={chartConfig} />
				<Grid
					container
					alignItems="center"
					className={classes.container}>
					<Grid item xs={12}>
						<Typography align="center">{clusterName}</Typography>
					</Grid>
					<Grid item xs={12}>
						{linkUrl && linkTitle ? (
							<Link
								rel="noopener noreferrer"
								target="_blank"
								underline="none"
								align="center"
								href={linkUrl}
								style={{display: "block"}}>{linkTitle}</Link>
							: null
						) : null}
						{!clusterName ? (
							<Typography align="center" style={{marginTop: 12}}>{clickPointText}</Typography>
						) : null}
					</Grid>
				</Grid>
			</React.Fragment>
		);
	}
}

SentimentChart.propTypes = {
	classes: PropTypes.object.isRequired,
	chartConfig: PropTypes.object,
	clusterName: PropTypes.string,
	linkUrl: PropTypes.string,
	linkTitle: PropTypes.string,
	clickPointText: PropTypes.string
};

export default withStyles(styles)(SentimentChart);
